import { useCallback, useRef } from 'react';

import {
  deleteCookie,
  getActiveFormsV2 as getActiveForms,
  NotificationManager,
  prepareRequest,
  StorageManager,
} from '@atlas/core';

import {
  OAUTH_REGISTER_INFO_COOKIE,
  OAUTH_REGISTER_INFO_TOKEN_STORAGE_KEY,
} from 'src/common/constants';

import { prepareGoogleRegistrationForm } from '../helpers/transformRegistration';

const useOAuthRegistrationForm = () => {
  const isOAuthRegistrationRef = useRef(false);

  const getActiveFormsWithOAuth = useCallback(async options => {
    const token = StorageManager.getItem(OAUTH_REGISTER_INFO_TOKEN_STORAGE_KEY);

    if (!token) {
      return getActiveForms(options);
    }

    try {
      const request = prepareRequest({
        method: 'GET',
        url: `client/registration-info/${token}`,
      });

      const data = await request();
      const form = prepareGoogleRegistrationForm(data);

      isOAuthRegistrationRef.current = true;

      return [form];
    } catch (error) {
      NotificationManager.notify({
        message: 'social_login_error',
        status: 'error',
        type: 'notification',
      });

      return getActiveForms(options);
    } finally {
      StorageManager.removeItem(OAUTH_REGISTER_INFO_TOKEN_STORAGE_KEY);
      deleteCookie(OAUTH_REGISTER_INFO_COOKIE);
    }
  }, []);

  return {
    getActiveFormsWithOAuth,
    isOAuthRegistrationRef,
  };
};

export default useOAuthRegistrationForm;
